import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

export type ToggleSwitchTone = 'default' | 'warning';

/**
 * Controlled: it never flips itself. A click emits the requested value and the caller decides, so a change that
 * needs confirmation first cannot leave the switch showing a state that was never applied.
 */
@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./toggle-switch.component.scss'],
})
export class ToggleSwitchComponent {
  @Input() checked = false;
  @Input() disabled = false;

  /** Looks disabled but keeps hover and focus, so a tooltip explaining why can still show. */
  @Input() softDisabled = false;

  /** Inside another control the switch is a state indicator only, so it renders no button of its own. */
  @Input() interactive = true;

  @Input() tone: ToggleSwitchTone = 'default';
  @Input() ariaLabel = '';

  @Output() checkedChange = new EventEmitter<boolean>();

  onClick(): void {
    if (this.disabled) {
      return;
    }

    this.checkedChange.emit(!this.checked);
  }
}
